import React from 'react'
import './final.css'

function Final() {
  return (
    <div className='last-bg text-center'>
      <h2 className='sig'>Download the app now.</h2>
      <p className='para'>Available on your favorite store. Start your premium experience now</p>
      <p className='para1'>Most calendars are <br/> designed for teams.</p>
        <form class="form-inline my-2 my-lg-0 corts">
            <button class="btn-3 btn-outline- my-2 my-sm-0" type="submit">Playstore</button>
            <button class="btn-4 btn-outline- my-2 my-sm-0" type="submit">App store</button>
            <button class="btn-5 btn-outline- my-sm-3" type="submit">Buy now</button>
            <button class="btn-6 btn-outline- my-2 my-sm-0" type="submit">Try for free</button>
        </form>
    </div>
  )
}

export default Final
